(function ($) {
    'use strict';

    $(document).on('change', '[data-wc-account-navigation-select]', function () {
        var url = $(this).val();

        if (url) {
            window.location.assign(url);
        }
    });
}(jQuery));
